import React, { useRef, useState, useCallback, useEffect } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  useListContext,
  Datagrid,
  ListContextProvider,
} from 'react-admin';

import { Card, Divider, Tabs, Tab } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { formatDateDDMMYYYYHHmm } from '../../utils';
import { STATUS_ATIVO, STATUS_DELETADO } from '../../utils/constants';
import { PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR } from '../../utils/dadosTelas';
import DialogoCreateEdit from './DialogoCreateEdit';
import DialogoDeletar from './DialogoDeletar';
//import ActionsField from './fields/ActionsField';
import DataField from './fields/DataField';
import ProdutoField from './fields/ProdutoField';
import QuantidadeField from './fields/QuantidadeField';
import QuantidadeFieldDisponivel from './fields/QuantidadeFieldDisponivel';
import ValorField from './fields/ValorField';
import Filter from './Filter';

const PostPanel = (props) => (
  <div>
    <div>{`Data de Criação: ${formatDateDDMMYYYYHHmm(
      props.record.created_at,
    )}`}</div>
    {props.record.criador ? (
      <div>{`Criador: ${props.record.criador.username}`}</div>
    ) : null}
    {props.record.atualizador ? (
      <div>{`último a Atualizar: ${props.record.atualizador.username}`}</div>
    ) : null}
    {props.record.deletador ? (
      <div>{`Quem Deletou: ${props.record.deletador.username}`}</div>
    ) : null}
  </div>
);

const tabs = [
  { id: 'ativos', name: 'Confirmados' },
  { id: 'inativos', name: 'Cancelados' },
];
//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);
  const refDialogoCreateEdit = useRef(null);
  const refDialogoDeletar = useRef(null);

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setAtivos(ids);
          break;
        case STATUS_DELETADO:
          setInativos(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'ativos' ? STATUS_ATIVO : STATUS_DELETADO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  const handleClose = () => {
    refresh();
  };

  function handleCriar() {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleCreate();
    }
  }

  function handleEdit({ id }) {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleEdit(id);
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoDeletar.current) {
      refDialogoDeletar.current.handleOpen(id);
    }
  }

  return (
    <>
      <Title title="Verbas de Produtos" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} handleCriar={handleCriar} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Divider />
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: ativos }}>
              <Datagrid {...props}>
                <TextField source="id" label="ID" />
                <ProdutoField source="produto_id" label="Produto" />
                <DataField source="data" label="Validade" />
                <ValorField source="verba_unitaria" label="Verba Unitária" />
                <QuantidadeField source="qtde" label="Quantidade Liberada" />
                <QuantidadeFieldDisponivel
                  source="qtde"
                  label="Quantidade Disponível"
                />
                <ValorField source="verba_total" label="Verba Total" />
                <ActionsField
                  source="lala"
                  label="Ações"
                  /* handleEdit={handleEdit}
                  handleDeletar={handleDeletar} */
                  actions={[
                    {
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (record) => handleEdit(record),
                      disabled: (record) => record.status !== STATUS_ATIVO,
                      show: () => true,
                    },
                    {
                      title: 'Deletar',
                      icon: <DeleteOutlineIcon />,
                      onClick: (record) => handleDeletar(record),
                      disabled: (record) => record.status !== STATUS_ATIVO,
                      show: () => true,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_DELETADO && (
            <ListContextProvider value={{ ...listContext, ids: inativos }}>
              <Datagrid {...props}>
                <TextField source="id" label="ID" />
                <ProdutoField source="produto_id" label="Produto" />
                <DataField source="data" label="Validade" />
                <ValorField source="verba_unitaria" label="Verba Unitária" />
                <QuantidadeField source="qtde" label="Quantidade Liberada" />
                <ValorField source="verba_total" label="Verba Total" />
                <ActionsField
                  source="lala"
                  label="Ações"
                  /*  handleEdit={handleEdit}
                  handleDeletar={handleDeletar} */
                  actions={[
                    {
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (record) => handleEdit(record),
                      disabled: (record) => record.status !== STATUS_ATIVO,
                      show: () => true,
                    },
                    {
                      title: 'Deletar',
                      icon: <DeleteOutlineIcon />,
                      onClick: (record) => handleDeletar(record),
                      disabled: (record) => record.status !== STATUS_ATIVO,
                      show: () => true,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoCreateEdit ref={refDialogoCreateEdit} handleClose={handleClose} />
      <DialogoDeletar ref={refDialogoDeletar} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR}>
    <ContainerMyList
      {...props}
      expand={<PostPanel />}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Verbas de Produtos"
      filterDefaultValues={{
        status: STATUS_ATIVO,
        periodo: {
          start: new Date(),
          end: new Date(),
        },
      }}
      component="div"
    />
  </ProtegerPagina>
);

export default List;
